<template>
    <div
        class="ppv2-flex ppv2-flex-wrap ppv2-w-full ppv2-step-wrapper md:ppv2-gap-[3.125vw]"
        :style="{ paddingLeft: normalizeSize(55) }"
    >
        <!-- Form Section -->
        <div class="form-section">
            <HeaderStep :step="step" :sizes="sizes" />

            <div class="ppv2-mb-6">
                <p class="ppv2-text-black poppinsLight" :style="{ fontSize: normalizeFontSize(15) }">
                    {{ $t('package.step1.description') }}
                </p>
            </div>

            <SelectableList
                :label="$t('package.step1.typeLabel')"
                v-model="selectedType"
                :options="typeOptions"
                class="ppv2-mb-6"
                @input="clearError('type')"
            />
            <div v-if="errors.type" class="ppv2-text-[#ed4b9e] ppv2-text-xs ppv2-mt-[-15px] ppv2-mb-4">
                {{ errors.type }}
            </div>

            <!-- Navigation Buttons -->
            <div class="form-actions" :class="{ '!ppv2-justify-end': !isCreationMode }">
                <BackButton v-if="isCreationMode" type="button" @click="$emit('previous-step')" />
                <BaseButton id="submit" type="button" @click="submitForm" variant="primary" :loading="loading">
                    {{ isCreationMode ? $t('experience.next') : $t('common.save') }}
                </BaseButton>
            </div>
        </div>

        <!-- Preview Panel -->
        <PreviewPackage :activeField="activeField" :step="step" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import normalizeSize from '../../../../utils/normalizeSize'
import HeaderStep from './HeaderStep.vue'
import PreviewPackage from './PreviewPackage.vue'
import BaseButton from '../../../Shared/BaseButton.vue'
import BackButton from '../../../Shared/BackButton.vue'
import SelectableList from '../../../Shared/SelectableList.vue'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'PackageStep1',
    components: {
        HeaderStep,
        PreviewPackage,
        BaseButton,
        BackButton,
        SelectableList,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
        isCreationMode: { type: Boolean, default: false },
    },
    data() {
        return {
            activeField: null,
            errors: {},
            initialFormData: null,
            typeOptions: [
                {
                    label: this.$t('package.step1.types.specific.label'),
                    value: 'specificPrestation',
                    subtitle: this.$t('package.step1.types.specific.subtitle'),
                },
                {
                    label: this.$t('package.step1.types.family.label'),
                    value: 'family',
                    subtitle: this.$t('package.step1.types.family.subtitle'),
                },
            ],
        }
    },
    computed: {
        ...mapGetters('package', ['selectedType', 'isStep1Valid', 'loading']),
        selectedType: {
            get() {
                return this.$store.getters['package/selectedType']
            },
            set(value) {
                this.$store.dispatch('package/setSelectedType', value)
            },
        },
    },
    mounted() {
        this.initialFormData = JSON.stringify(this.selectedType)
    },
    methods: {
        normalizeFontSize,
        ...mapActions('package', ['setSelectedType', 'clearError']),
        normalizeSize,

        hasChanges() {
            return JSON.stringify(this.selectedType) !== this.initialFormData
        },

        resetInitialState() {
            this.initialFormData = JSON.stringify(this.selectedType)
        },

        clearError(field) {
            if (this.errors[field]) {
                delete this.errors[field]
            }
        },

        submitForm() {
            this.errors = {}

            if (!this.selectedType) {
                this.errors.type = this.$t('package.step1.errors.typeRequired')
                return
            }

            this.$emit('next-step')
        },
    },
}
</script>

<style scoped>
.form-section {
    flex: 1;
}

.form-actions {
    display: flex;
    gap: 16px;
    margin-top: 40px;
}
</style>
